<template>
  <div class="d-flex flex-wrap mb-1 justify-content-center">
    <div v-for="courseProgres in Progress" :key="courseProgres.course.id" class="col-md-4 col-12 mb-1">
      <b-card no-body  class="justify-content-between h-100 ">
        <b-card-header>
          <h4 class="mb-0">
             
            {{courseProgres.course.name}}
            </h4>
          
        </b-card-header>
        <div v-if="loading" class="my-1">
          <b-skeleton
            class="mx-auto"
            type="avatar"
            width="300px"
            height="300px"
          ></b-skeleton>
        </div>
        <!-- apex chart -->
        <vue-apex-charts
          v-else
          type="radialBar"
          height="250"
          class="mb-1"
          :options="goalOverviewRadialBar"
          :series="[Math.trunc(courseProgres.progress_value)]"
        />
        <b-row class="text-center mx-0">
          <b-col
            cols="6"
            class="border-top border-right d-flex align-items-center flex-column  py-1 "
          >
            <b-card-text class="text-muted mb-1"> تعداد کل جلسات </b-card-text>
            <b-skeleton v-if="loading" width="60px"></b-skeleton>
            <h3 v-else class="font-weight-bolder mb-0">
              {{ courseProgres.course_session_count }}
            </h3>
          </b-col>

          <b-col
            cols="6"
            class="border-top d-flex align-items-center flex-column py-1"
          >
            <b-card-text class="text-muted mb-1">جلسات دیده شده </b-card-text>
            <b-skeleton v-if="loading" width="60px"></b-skeleton>
            <h3 v-else class="font-weight-bolder mb-0">
              {{ courseProgres.see_session_count }}
            </h3>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BRow,
  BCol,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

const $strokeColor = "#ebe9f1";
const $textHeadingColor = "#5e5873";
const $goalStrokeColor2 = "#51e5a8";
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BRow,
    BCardText,
    BCol,
    BSkeleton,
  },

  data() {
    return {
      Progress: {},
      loading: false,
      statistic: {
        completed: "",
        inProgress: "",
        series: [],
      },
      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "77%",
            },
            track: {
              background: $strokeColor,
              strokeWidth: "50%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: "2.86rem",
                fontWeight: "600",
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    };
  },

   
  created() {
    this.getUserProgress();
  },
  methods: {
    async getUserProgress() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `panel/users/${this.$route.params.id}/progress`
        );
        this.Progress = data.data;
      } catch (e) {}

      this.loading = false;
    },
  },
};
</script>
